import axios from "axios";

/**
 * PUT a recording straight to the signed storage URL the API handed out.
 *
 * Plain fetch, not the API client: the URL is Cloud Storage's, signed for this
 * one object, and must not carry the therapist's bearer token.
 */
export async function putToSignedUrl(uploadUrl: string, body: Blob, contentType: string): Promise<void> {
    const response = await fetch(uploadUrl, {
        method: "PUT",
        body,
        headers: { "Content-Type": contentType },
    });
    if (!response.ok) {
        throw new Error(`GCS upload failed: ${response.status}`);
    }
}

/** The API refused to process a recording because the patient has not consented to AI use. */
export const isAiConsentRequired = (err: unknown): boolean =>
    axios.isAxiosError(err) &&
    err.response?.status === 409 &&
    err.response?.data?.detail === "ai_consent_required";
